import React from 'react';

import { Box, Button } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const EditionButtons = ({
    editionDisabled,
    handleClickCancel,
    handleClickSave,
    isUpdatingTemplate,
}) => {
    const { t } = useTranslation();

    if (editionDisabled) return null;

    return (
        <Box display="flex" flexDirection="column" gap={1} mb={2}>
            <Button
                disabled={isUpdatingTemplate}
                fullWidth
                onClick={() => handleClickSave()}
                type="button"
            >
                {isUpdatingTemplate ? t('Saving').concat('...') : t('Save')}
            </Button>
            <Button
                fullWidth
                onClick={() => handleClickCancel()}
                type="button"
                variant="text"
            >
                {t('Cancel')}
            </Button>
        </Box>
    );
};

EditionButtons.propTypes = {
    editionDisabled: PropTypes.bool,
    handleClickCancel: PropTypes.func,
    handleClickSave: PropTypes.func,
    isUpdatingTemplate: PropTypes.bool,
};

export default EditionButtons;
